import React from 'react';
import { Popup } from 'semantic-ui-react';
import { I18n } from 'react-redux-i18n';
import { i18nKeys } from '../constants';
import styles from './ActivityCard.module.css';

interface PayloadTooltipProps {
  payload: { key: string; value: string }[];
  trigger: React.ReactNode;
}

/**
 * Tooltip component to display payload data as key-value pairs
 */
const PayloadTooltip: React.FC<PayloadTooltipProps> = ({ payload, trigger }) => {
  if (!payload || payload.length === 0) {
    return <>{trigger}</>;
  }

  return (
    <Popup
      trigger={<span className={styles.payloadTrigger}>{trigger}</span>}
      hoverable
      position="bottom left"
      className={styles.payloadPopup}
      wide="very"
      inverted
    >
      <div className={styles.payloadContent}>
        <div className={styles.payloadHeader}>
          {I18n.t(i18nKeys.ADDITIONAL_DATA)}
        </div>
        <div className={styles.payloadList}>
          {payload.map(({ key, value }, index) => (
            <div key={index} className={styles.payloadItem}>
              <span className={styles.payloadKey}>{key}:</span>
              <span className={styles.payloadValue}>{value}</span>
            </div>
          ))}
        </div>
      </div>
    </Popup>
  );
};

export default PayloadTooltip;
